interface Props { title: string; slug: string; metaDescription: string; }

const SerpPreview = ({ title, slug, metaDescription }: Props) => {
  const url = `maroctransfers.com › guide › blog › ${slug || "..."}`;
  return (
    <div className="rounded-lg border border-border bg-background p-4 font-sans">
      <p className="text-xs text-muted-foreground">Aperçu Google</p>
      <div className="mt-2">
        <p className="text-xs text-emerald-700">{url}</p>
        <p className="text-[18px] leading-snug text-[#1a0dab] hover:underline cursor-pointer truncate">{title || "Titre de l'article"}</p>
        <p className="text-sm text-[#4d5156] mt-1 line-clamp-2">{metaDescription || "Aucune meta description renseignée."}</p>
      </div>
    </div>
  );
};

export default SerpPreview;